import App from '@/App';
import { FORM_TYPE, ROUTES } from '@/configs/constants';
import withAuthentication from '@/hooks/withAuthentication';
import withNonAuthentication from '@/hooks/withNonAuthentication';
import AdminPanelLayout from '@/layouts/AdminPanelLayout';
import FormPanelLayout from '@/layouts/FormPanelLayout';
import {
    DashboardPage, SignInPage, NotFoundPage, UserManagementPage,
    ForgotPasswordPage, VerifyOtpPage, ResetPasswordPage, ChangePasswordPage,
    ShopManagementPage, GeneralSettingPage, EditUserPage, EditShopPage,
    AppointmentPage, AppointmentDetailPage, ReviewManagement, ViewReviewPage,
    NotificationManagementPage, TopicEditPage, TopicPage,
    SeoToolPage,
    PromotionManagementPage,
    ReferralCodesPages,
    NewsPage, NewsEditPage
} from '@/pages';
import News from '@/pages/news';
import FormPromotion from '@/pages/promotion/components/FormPromotion';
import FormNews from '@/pages/news/components/NewsForm';
import { GENERAL_SETTING_TYPE } from '@/types/enums';
import { createBrowserRouter, redirect } from 'react-router-dom';
import NewsForm from '@/pages/news/components/NewsForm';
import NewsEdit from '@/pages/news/news-edit';
import TopicForm from '@/pages/forum/topic/components/TopicForm';

const AdminPanelLayoutWithAuthentication = withAuthentication(AdminPanelLayout);
const FormPanelLayoutWithNoneAuthentication = withNonAuthentication(FormPanelLayout);

export const router = createBrowserRouter([
    {
        path: '/',
        element: <App />,
        children: [
            {
                index: true,
                loader: () => redirect(ROUTES.dashboard.href)
            },
            {
                path: '/',
                element: <FormPanelLayoutWithNoneAuthentication />,
                children: [
                    {
                        path: ROUTES.signIn.href,
                        element: <SignInPage />
                    },
                    {
                        path: ROUTES.forgotPassword.href,
                        element: <ForgotPasswordPage />
                    },
                    {
                        path: ROUTES.verifyOtp.href,
                        element: <VerifyOtpPage />
                    },
                    {
                        path: ROUTES.resetPassword.href,
                        element: <ResetPasswordPage />
                    }
                ]
            },
            {
                path: '/',
                element: <AdminPanelLayoutWithAuthentication />,
                children: [
                    {
                        path: ROUTES.dashboard.href,
                        element: <DashboardPage />
                    },
                    {
                        path: ROUTES.userManagement.href,
                        element: <UserManagementPage />
                    },
                    {
                        path: `${ROUTES.userManagement.href}/:code`,
                        element: <EditUserPage />
                    },
                    {
                        path: ROUTES.shopManagement.href,
                        element: <ShopManagementPage />
                    },
                    {
                        path: `${ROUTES.shopManagement.href}/:code`,
                        element: <EditShopPage />
                    },
                    {
                        path: ROUTES.appointmentManagement.href,
                        element: <AppointmentPage />
                    },
                    {
                        path: ROUTES.appointmentDetail.href,
                        element: <AppointmentDetailPage />
                    },
                    {
                        path: ROUTES.reviewManagement.href,
                        element: <ReviewManagement />
                    },
                    {
                        path: `${ROUTES.reviewManagement.href}/:id`,
                        element: <ViewReviewPage />
                    },
                    {
                        path: ROUTES.promotionManagement.href,
                        element: <PromotionManagementPage />
                    },
                    {
                        path: ROUTES.promotionCreate.href,
                        element: <FormPromotion typeForm={FORM_TYPE.CREATE} />
                    },
                    {
                        path: `${ROUTES.promotionEdit.href}/:id`,
                        element: <FormPromotion typeForm={FORM_TYPE.EDIT} />
                    },
                    {
                        path: `${ROUTES.promotionClone.href}/:id`,
                        element: <FormPromotion typeForm={FORM_TYPE.CLONE} />
                    },
                    {
                        path: `${ROUTES.notificationManagement.href}`,
                        element: <NotificationManagementPage />
                    },
                    {
                        path: ROUTES.referralCodes.href,
                        element: <ReferralCodesPages />
                    },
                    {
                        path: `${ROUTES.seoTool.href}`,
                        element: <SeoToolPage />
                    },
                    {
                        path: ROUTES.contentSetting.href,
                        element: <></>
                    },
                    {
                        path: ROUTES.aboutUs.href,
                        element: <GeneralSettingPage type={GENERAL_SETTING_TYPE.AboutUs} />
                    },
                    {
                        path: ROUTES.miaPolicy.href,
                        element: <GeneralSettingPage type={GENERAL_SETTING_TYPE.MiaPolicy} />
                    },
                    {
                        path: ROUTES.privacyPolicy.href,
                        element: <GeneralSettingPage type={GENERAL_SETTING_TYPE.PrivacyPolicy} />
                    },
                    {
                        path: ROUTES.forum.href,
                        element: <TopicPage />
                    },
                    {
                        path: ROUTES.topicCreate.href,
                        element: <TopicForm isEdit={false} />
                    },
                    {
                        path: `${ROUTES.forum.href}/:code`,
                        element: <TopicEditPage />
                    },
                    {
                        path: `${ROUTES.forum.href}/:code`,
                        element: <NotFoundPage />
                    },
                    {
                        path: ROUTES.news.href,
                        element: <NewsPage />
                    },
                    {
                        path: ROUTES.newsCreate.href,
                        element: <NewsForm typeForm={FORM_TYPE.CREATE} />
                    },
                    {
                        path: `${ROUTES.news.href}/:code`,
                        element: <NewsEditPage />
                    },

                    {
                        path: ROUTES.changePassword.href,
                        element: <ChangePasswordPage />
                    },
                    {
                        path: '*',
                        element: <NotFoundPage />
                    }
                ]
            }
        ]
    }
]);
